"use client";

import { useQuery, UseQueryOptions, UseQueryResult, QueryKey } from "@tanstack/react-query";
import { useIsPublicPage } from "./use-is-public-page";

/**
 * A wrapper around useQuery that automatically disables queries on public pages.
 * This prevents unauthenticated API calls on login/join pages.
 *
 * Usage is identical to useQuery - just replace useQuery with useAuthenticatedQuery.
 */
export function useAuthenticatedQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {
  const isPublicPage = useIsPublicPage();

  return useQuery({
    ...options,
    enabled: (options.enabled ?? true) && !isPublicPage,
  });
}
